import { HeaderProps } from 'react-big-calendar';
import React from "react";
import {styled} from "@mui/material";
import theme, {FONTS} from "../../../constants/theme";
import {scale} from "../../../utils";
import Text from "../../text";
import dayjs from "dayjs";
import {useMediaQuery} from "@mui/system";

const Wrapper = styled('div')({
  display: "flex",
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 500,
  height: scale(23),
  width: scale(171),
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.text.primary,
  fontFamily: 'Poppins',
  fontSize: scale(16),
  textTransform: 'uppercase',
  padding: 0,
  [theme.breakpoints.down('sm')]: {
    backgroundColor: theme.palette.white.main,
    color: theme.palette.ceramic.contrastText,
  }
});

interface Props extends HeaderProps {
  currentDate: Date;
}

const WeekDayHeader: React.FC<Props> = ({ date, localizer, currentDate }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const desktopDayName = localizer.format(date, 'dddd', 'it-IT');
  const mobileDayName = localizer.format(date, 'dd', 'it-IT')[0];
  const dayName = isMobile ? mobileDayName : desktopDayName;

  const today = dayjs();
  const viewedMonth = dayjs(currentDate);

  const isToday =
    today.day() === dayjs(date).day() &&
    today.month() === viewedMonth.month() &&
    today.year() === viewedMonth.year();
  return (
    <Wrapper>
      <Text
        text={dayName}
        fontFamily={FONTS.MONTSERRAT}
        fontSize={scale(16)}
        color={isMobile ? theme.palette.lightGray.main : theme.palette.text.primary}
        fontWeight={ isToday ? 'bold' : 500}
      />
    </Wrapper>
  );
};

export default WeekDayHeader;
